import { ReactComponent as LeaveSvg } from "../icons/leave.svg"
import { ReactComponent as SoundSvg } from "../icons/sound.svg"
import { ReactComponent as UserPenSvg } from "../icons/user-pan.svg"

import "./record-detail.less"
import { useContext, useEffect, useRef, useState } from "react"
import { MeetingAttendee, MeetingMinute, MeetingRecord } from "@/declare/interface/meeting"
import { MeetingMinuteRecordBottom } from "../meeting-minute-record-button-test"
import { useParams } from "react-router-dom"
import { Button, Input, Spin, Tooltip, message } from "antd"
import { exportMeetingWord, findMeetingDetailById, updateMeetingRecord } from "@/declare/api/meeting"
import ContextMenu from "@/baseui/right-menu/context-menu"
import pinyin from "pinyin"
import classNames from "classnames"
import { MeetingMinuteStatus } from "@/declare/enums/meeting-minute-status"
import { downloadMinioFile, getFileUrlByMd5 } from "@/declare/api/file"
import { DownloadFile, DownloadState } from "@/panel/download-panel"
import { DownloadContext } from "@/App"
import {
    RedoOutlined
} from '@ant-design/icons';

const colorList = [
    { nameColor: "#B449C2", textColor: "#F7E9F7" },
    { nameColor: "#3295FB", textColor: "#EAF5FF" },
    { nameColor: "#2CB8C5", textColor: "#E5F7F8" },
    { nameColor: "#5AC262", textColor: "#ECF7EC" },
    { nameColor: "#A7DA2C", textColor: "#F2FAE6" },
    { nameColor: "#FDA633", textColor: "#FFF8EA" },
    { nameColor: "#FFF8EA", textColor: "#FFF8EA" },
]
const defaultNameColor = "#5E6FC4"
const defaultTextColor = "#ECEFF8"

const { TextArea } = Input;

interface IProps {
    /**
     * 记录列表
     */
    recordList: MeetingRecord[]
    /**
     * 会议参与人列表
     */
    attendeeList: MeetingAttendee[]
    /**
     * 会议纪要状态
     */
    status: number
    /**
     * 会议纪要主体信息
     */
    detail: MeetingMinute
    /**
     * 设置父记录列表回调
     * @param recordList 
     * @returns 
     */
    setRecordList?: (recordList: MeetingRecord[]) => void

    setStatus: (status: number) => void
}

export default function MeetingMinuteRecordDetail(props: IProps) {

    const { meetingId } = useParams();
    const { recordList, setRecordList, attendeeList, status, setStatus } = props

    /**
     * 设置暂停状态
     */
    const [paused, setPaused] = useState<boolean>(true);

    const [myRecordList, setMyRecordList] = useState<MeetingRecord[]>([]) // 页面本身的list

    const [openMenu, setOpenMenu] = useState<boolean>(false); // 用户选择弹窗是否可见
    const [cmTop, setCmTop] = useState<number>(); // 用户选择弹窗的定位
    const [cmLeft, setCmLeft] = useState<number>(); // 用户选择弹窗的定位

    const [activeItem, setActiveItem] = useState<MeetingRecord>(null)

    const [attendeeSetList, setAttendeeSetList] = useState<string[]>([])

    const [soundUrl, setSoundUrl] = useState<string>(null)

    const [soundDuration, setSoundDuration] = useState<number>(0)

    const [nameColorMap, setNameColorMap] = useState<{ [key: string]: { nameColor: string, textColor: string } }>({})

    const [acitveAttendee, setActiveAttendee] = useState<MeetingAttendee>(null)

    const downloadContext = useContext<DownloadState>(DownloadContext);


    useEffect(() => {
        let midMap = { ...(nameColorMap || {}) }
        for (let i = 0; i < attendeeList.length; i++) {
            if (!midMap[attendeeList[i].name]) {
                midMap[attendeeList[i].name] = colorList[i % 7]
            }
        }
        setNameColorMap({ ...midMap })
        if (attendeeList?.length > 0) {
            setActiveAttendee(attendeeList[0])
        }

    }, [attendeeList])

    useEffect(() => {
        if (!meetingId || isNaN(+meetingId)) {
            return;
        }
    }, [meetingId])

    useEffect(() => {
        setMyRecordList([...(recordList || [])])
    }, [recordList])

    useEffect(() => {
        if (!paused) {
            scrollListBodyToBottom()
        }
    }, [myRecordList])

    const onTextChange = (text: string) => {
        if (recordList.length < 1) return
        recordList[myRecordList.length - 1].text = text
        setRecordList([...recordList])
        scrollListBodyToBottom()
    }

    const scrollListBodyToBottom = () => {
        let dom = document.getElementById("meeting-record-list-body");
        if (!dom) return;

        dom.scrollTo({
            top: dom.scrollHeight,
            behavior: 'smooth'
        });
    };

    /**
     * 修改内容
     * @param recordIndex 
     * @param value 
     */
    const onChangeMeetingRecordDetail = (recordIndex: number, value: string) => {
        myRecordList[recordIndex].text = value
        setMyRecordList([...myRecordList])
        updateMeetingRecord(myRecordList[recordIndex].id, { text: value }).catch(e => {
            message.error("更新失败！")
        })
    }

    /**
     * 获取拼音首字符拼接string
     * @param name 
     * @returns 
     */
    const getPinYinTitle = (name: string) => {
        if (name?.length <= 0) return ""
        let namestr = pinyin(name, {
            style: pinyin.STYLE_FIRST_LETTER,  // 正常拼音风格
            heteronym: false,            // 不启用多音字
        }).join("").toLocaleUpperCase()
        return namestr
    }

    /**
     * 点击头像显示切换讲话人弹窗
     * @param record 
     */
    const onClickReSetSpeaker = (record: MeetingRecord) => {
        setActiveItem(record)
        let doc = document.getElementById("meeting-record-item-" + record.id)
        if (doc) {
            const rect = doc.getBoundingClientRect();
            setOpenMenu(true)
            setCmLeft(rect.left + 54)
            setCmTop(rect.top + 18)
            setAttendeeSetList(Array.from(new Set(attendeeList.map(a => a.name))))
        }
    }

    /**
     * 弹窗确认修改讲话人
     * @param name 
     * @returns 
     */
    const onChangeRecordName = (name: string) => {
        if (!activeItem) return
        let index = myRecordList.findIndex(r => r.id === activeItem.id)
        if (index < 0) return
        myRecordList[index].name = name
        setMyRecordList([...myRecordList])
        updateMeetingRecord(myRecordList[index].id, { name: name }).catch(e => {
            message.error("更新失败！")
        }).finally(() => {
            setOpenMenu(false)
        })
    }

    /**
     * 获取时间str
     * @param seconds 
     * @returns 
     */
    const formatDuration = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    /**
     * 点击播放音频
     * @param soundMd5 
     */
    const onClickToPlaySound = (soundMd5: string, duration: number) => {
        if (soundMd5?.length > 0) {
            getFileUrlByMd5(soundMd5).then(res => {
                setSoundUrl(res.data)
            })
            setSoundDuration(duration)
        }
    }

    const onReceiveWebSocketUpdateRecord = (record: MeetingRecord) => {
        // recordList
        if (!record?.id) return
        let reIndex = recordList.findIndex(r => r.id == record.id)
        if (reIndex < 0) return
        recordList[reIndex] = record
        setRecordList([...recordList])
    }

    const addRecordItem = (record: MeetingRecord) => {
        recordList.push(record)
        setRecordList([...recordList])
    }

    const onClickEnd = () => {
        setStatus(MeetingMinuteStatus.ANALYSIS)
    }

    const getColor = (recordName: string) => {
        if (recordName?.length < 1) {
            return {
                nameColor: defaultNameColor,
                textColor: defaultTextColor
            }
        }
        if (nameColorMap[recordName]) {
            return {
                nameColor: nameColorMap[recordName].nameColor,
                textColor: nameColorMap[recordName].textColor
            }
        } else {
            return {
                nameColor: defaultNameColor,
                textColor: defaultTextColor
            }
        }

    }

    const onClickReExportWord = () => {
        setStatus(MeetingMinuteStatus.FILE_ANALYSIS)
        exportMeetingWord(+meetingId).catch(e => {
            console.log('e', e)
        })

    }

    const onClickDownloadFile = () => {
        findMeetingDetailById(+meetingId).then(res => {
            let meeting: MeetingMinute = res.data
            const meetinFile: DownloadFile = {
                filename: meeting.name,
                md5: meeting.md5,
                suffix: meeting.suffix,
                objectName: '',
                bucketName: ''
            }
            // downloadContext.startDownload([meetinFile])
            downloadMinioFile(meeting.filePath).then(res => {
                if (res.data != null) {
                    downloadFile(meeting.name, meeting.suffix, res.data)
                }
            })
        })

    }

    const downloadFile = (filename, suffix, blob: any) => {
        let link = document.createElement("a");
        link.style.display = 'none'
        let href = window.URL.createObjectURL(blob);
        let downloadName = `${filename}${suffix || ''}`;
        link.setAttribute('href', href);
        // link.setAttribute('download', downloadName);
        link.download = downloadName
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


    return (
        <>
            {[MeetingMinuteStatus.COMPLETED, MeetingMinuteStatus.FILE_ANALYSIS].includes(status) && (
                <div style={{ display: "flex" }}>
                    <Tooltip title="导出会议纪要">
                        <LeaveSvg onClick={() => { onClickDownloadFile() }} className="leave-icon" />
                    </Tooltip>
                    <Spin spinning={status == MeetingMinuteStatus.FILE_ANALYSIS}>
                        <Tooltip title="重新生成会议纪要">
                            <RedoOutlined style={{ marginLeft: '8px', fontSize: '20px' }} onClick={() => { onClickReExportWord() }} className="leave-icon" />
                        </Tooltip>
                    </Spin>
                </div>
            )}
            <div className="attendee-list">
                {attendeeList.map(attendee => (
                    <div className={classNames({
                        "attendee-item": true,
                        "attendee-item-active": acitveAttendee?.id == attendee.id,
                    })} onClick={() => {
                        if (acitveAttendee?.id != attendee.id) {
                            setActiveAttendee(attendee)
                        }
                    }}>
                        {attendee.name}
                    </div>
                ))}
            </div>
            <div className="record-list" id="meeting-record-list-body">
                {myRecordList?.map((record, index) => {
                    // 是否需要与下一个record合并
                    let needCombineNext: boolean = false
                    if (index < myRecordList?.length - 1 && record.name) {
                        let nextRecord = myRecordList[index + 1]
                        if (nextRecord?.name == record?.name) {
                            needCombineNext = true
                        }
                    }
                    // 是否需要与上一个record合并
                    let needCombinePrev: boolean = false
                    if (index > 0 && record?.name) {
                        let prevReocrd = myRecordList[index - 1]
                        if (prevReocrd?.name == record?.name) {
                            needCombinePrev = true
                        }
                    }
                    return (
                        <div className="record-item" key={index}>
                            <div className="item-head" >
                                {!needCombinePrev && (
                                    <>
                                        <div
                                            style={{ background: getColor(record?.name).nameColor }}
                                            className="name"
                                            id={"meeting-record-item-" + record.id}
                                            onClick={(e) => { onClickReSetSpeaker(record) }}
                                        >
                                            {record?.name || "讲话人A"}
                                        </div>
                                    </>
                                )}
                                {needCombinePrev && (
                                    <div
                                        className="hide-name"
                                        id={"meeting-record-item-" + record.id}
                                        onClick={(e) => { onClickReSetSpeaker(record) }}
                                    />
                                )}
                                {status == MeetingMinuteStatus.COMPLETED && (
                                    <div className="sound-svg">
                                        <div className="svg-hide">
                                            <SoundSvg onClick={() => { onClickToPlaySound(record?.md5, record.duration) }} className="sound-icon" />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="divider" />
                            <div
                                className="item-body"
                                style={{
                                    backgroundColor: getColor(record?.name).textColor,
                                    marginBottom: needCombineNext ? "0px" : "8px",
                                    borderTopLeftRadius: needCombinePrev ? "0px" : "6px",
                                    borderTopRightRadius: needCombinePrev ? "0px" : "6px",
                                    borderBottomLeftRadius: needCombineNext ? "0px" : "6px",
                                    borderBottomRightRadius: needCombineNext ? "0px" : "6px",
                                }}
                            >
                                <div className="body-detail">
                                    <TextArea
                                        variant="borderless"
                                        autoSize
                                        value={record?.text || ""}
                                        onChange={(e) => { onChangeMeetingRecordDetail(index, e.target.value) }}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            <div className="record-bottom">
                <MeetingMinuteRecordBottom
                    paused={paused}
                    setPaused={setPaused}
                    soundUrl={soundUrl}
                    soundDuration={soundDuration}
                    status={status}
                    onTextChange={onTextChange}
                    addRecordItem={addRecordItem}
                    onEnd={onClickEnd}
                    onReceiveChange={onReceiveWebSocketUpdateRecord}
                    activeAttendee={acitveAttendee}
                />
            </div>

            <ContextMenu
                visible={openMenu}
                left={cmLeft}
                top={cmTop}
                wrapperClassname="meeting-record-user-modal"
                width={60}
                onCancel={() => { setOpenMenu(false) }}
            >
                {attendeeSetList?.map(attName => (
                    <div className={classNames({
                        "user-att-item": true,
                        "user-att-item-active": activeItem.name == attName
                    })}
                        onClick={() => {
                            onChangeRecordName(attName)
                        }}
                    >
                        {attName}
                    </div>
                ))}

            </ContextMenu>
        </>

    )
}